import { createSelector } from '@reduxjs/toolkit';
import { EntityStoreName } from 'app/enums/store';
import { AppState } from 'app/interfaces/store';

import { entityAdapter } from 'modules/notifications/store/notifications/adapter';

const notificationsState = (state: AppState) => state[EntityStoreName.Notifications];

const selectAll = entityAdapter.getSelectors<AppState>(
  (state) => state[EntityStoreName.Notifications]
).selectAll;

const selectTotal = createSelector(notificationsState, (state) => state.total);

const selectOffset = createSelector(notificationsState, (state) => state.offset);

export const notificationsSelector = {
  all: selectAll,
  total: selectTotal,
  offset: selectOffset,
};
